import { List, ListItem, Row, Typography } from 'darrius';
import { type ISubCategoriesProps } from '../../../modules/profile/shared/pageProps/getSubCategoriesProps/@interfaces';

import styles from './ProfileServices.module.scss';

interface IProfileServices {
  services: ISubCategoriesProps;
}

export const ProfileServices = ({ services }: IProfileServices) => {
  if (!services) return null;

  return (
    <Row>
      <section className="services space-top" id={services.id}>
        <Typography.Subtitle
          size="l"
          className={styles['profile-services__title']}
        >
          {services.title}
        </Typography.Subtitle>
        <List className={`service__list ${styles['list--with-bullet']}`}>
          {services.items.map((item) => (
            <ListItem key={item}>
              <Typography.Text className={styles['profile-services__list']}>
                {item}
              </Typography.Text>
            </ListItem>
          ))}
        </List>
      </section>
    </Row>
  );
};
